import { Button } from '../Button'
import { StyleFn } from '..'

export const Calendar: StyleFn = (theme) => {
  const { color, font, size } = theme
  const { root: buttonBase, _ghost, _medium } = Button(theme)

  const colors =
    color.type === 'light'
      ? {
          default: color.palette.coolgrey[60],
          inverse: color.palette.coolgrey[30],
          selected: color.palette.white,
          indicator: color.brand.light,
        }
      : {
          default: color.palette.coolgrey[30],
          inverse: color.palette.coolgrey[50],
          selected: color.brand.light,
          indicator: color.palette.white,
        }

  return {
    root: {
      display: 'inline-block',
      position: 'relative',
      minWidth: '18rem',
      minHeight: '18rem',
    },
    navbar: {
      display: 'flex',
      position: 'absolute',
      left: 0,
      right: 0,
      maxWidth: '18rem',
      justifyContent: 'space-between',
      padding: size.spacing[8],
    },
    navbar_select: {
      width: size.spacing[96],
    },
    months: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    month: {
      marginTop: size.spacing[8],
      padding: `${size.spacing[8]} ${size.spacing[4]}`,
      width: '18rem',
      // @see https://css-tricks.com/fighting-the-space-between-inline-block-elements/
      fontSize: 0,
    },
    month_today: {
      '& $caption': {
        color: colors.indicator,
      },
    },
    caption: {
      height: size.spacing[20],
      marginBottom: size.spacing[8],
      textAlign: 'center',
      color: colors.default,
      fontSize: font.size.medium,
      fontWeight: font.weight.bold,
    },
    weekday: {
      display: 'inline-block',
      width: 'calc(100% / 7)',
      padding: `${size.spacing[16]} 0 0`,
      color: colors.inverse,
      fontSize: font.size.small,
      textAlign: 'center',
    },
    day: {
      extend: [buttonBase, _ghost, _medium],
      width: 'calc(100% / 7)',
      borderRadius: 0,
      color: colors.default,
    },
    day_outside: {
      color: colors.inverse,
    },
    day_today: {
      border: `1px solid ${colors.indicator}`,
      borderRadius: 3,
      color: colors.indicator,
    },
    day_selected: {
      borderRadius: 3,
      backgroundColor: colors.indicator,
      color: colors.selected,
      "&[aria-pressed='true']": {
        backgroundColor: colors.indicator,
      },
      '&:hover': {
        backgroundColor: color.brand.normal,
      },
      '&:active': {
        backgroundColor: color.brand.normal,
      },
    },
    day_range: {
      backgroundColor: color.palette.warmgrey[20],
    },
  }
}
